// @ts-nocheck
import React, { useState, useContext, useEffect } from 'react';
import SCInput from '@/components/sc-controls/form-controls/sc-input';
import SCComboBox from '@/components/sc-controls/form-controls/sc-combobox';
import Helper from '@/utils/helper';
import * as Enums from '@/utils/enums';
import Fetch from '@/utils/Fetch';
import ToastContext from '@/utils/toast-context';
import PS from '@/services/permission/permission-service';
import CustomerService from '@/services/customer/customer-service';
import constants from '@/utils/constants';
import SCModal from "@/PageComponents/Modal/SCModal";
import ContactDeactivateModal from '@/components/modals/contact/ContactDeactivateModal';
import ContactRoleReplacementModal from '@/components/modals/contact/ContactRoleReplacementModal';
import {IconChevronLeft, IconPlus} from "@tabler/icons-react";
import {Group, Button, Title, Loader, Tooltip, Text, Badge, Box, Checkbox, SimpleGrid} from "@mantine/core";

function ManageContact({isNew, contact, module, moduleData, onSave, onCancel, canDeactivate = true, accessStatus, backButtonText}: any) {

    const [editCustomerPermission] = useState(PS.hasPermission(Enums.PermissionName.EditCustomer) || module == Enums.Module.Supplier);
    const toast = useContext(ToastContext);

    const [inputs, setInputs] = useState<any>({});    

    useEffect(() => {
        let inputState = {};
        if (isNew) {
            inputState = {
                FirstName: '',
                LastName: '',
                EmailAddress: '',
                MobileNumber: '',
                WorkNumber: '',
                HomeNumber: '',
                FaxNumber: '',
                IDNumber: '',
                SendEmail: true,
                SendSMS: true,
                Unsubscribe: false,
                IsPrimary: false
            };
            if (module == Enums.Module.Customer) {
                inputState = {...inputState, IsPrimaryAccount: false};
            } else if (module == Enums.Module.Supplier) {
                inputState = {...inputState, canLogin: false,
                    password: '',
                    confirmPassword: ''};
            }
        } else {
            inputState = {
                ID: contact.ID,                
                FirstName: contact.FirstName,
                LastName: contact.LastName,
                EmailAddress: contact.EmailAddress,
                MobileNumber: contact.MobileNumber,
                WorkNumber: contact.WorkNumber,
                HomeNumber: contact.HomeNumber,
                FaxNumber: contact.FaxNumber,
                IDNumber: contact.IDNumber,
                SendEmail: contact.SendEmail,
                SendSMS: contact.SendSMS,
                Unsubscribe: contact.Unsubscribe,
                IsPrimary: contact.IsPrimary,
                IsActive: contact.IsActive,
                RowVersion: contact.RowVersion,
            };
            if (module == Enums.Module.Customer) {
                inputState = { ...inputState, IsPrimaryAccount: contact.IsPrimaryAccount };
            } else if (module == Enums.Module.Supplier) {
                inputState = {
                    ...inputState,
                    canLogin: contact.AuthUserIsActive,
                    UserIsActive: contact.AuthUserIsActive,
                    UserName: contact.UserName,
                    UserID: contact.UserID,
                    password: '',
                    confirmPassword: '',
                };
            }
        }

        setInputs(inputState);

        getDesignations();
    }, []);

    const handleInputChange = (e: any) => {
        let setter = {
            ...inputs,
            [e.name]: e.value
        };

        // set IsActive to true if either IsPrimary or IsPrimaryAccount gets selected
        if ((e.name === 'IsPrimary' || e.name === 'IsPrimaryAccount') && e.value) {
            setter.IsActive = true;
        }

        if (!isNew) {
            if (module == Enums.Module.Supplier && e.name === "EmailAddress" && !inputs.UserID && inputs.canLogin) {
                setter.UserName = e.value;
            }
        }

        setInputs(setter);
    };

    const handleEmailOnPaste = (value: any) => {
        if (value) {
            if (value.includes("<") && value.includes(">")) {

                let emailToTest = value.substring(value.indexOf("<") + 1, value.indexOf(">"));                
                let containsValidEmail = Helper.validateEmail(emailToTest);

                if (!containsValidEmail) {
                    return;
                }

                let firstname;
                let lastname;
                let email;

                let items = value.trim().split(" ");
                if (items) {                    
                    items = items.filter((x: any) => x != "");                  
                    if (items.length == 3) {
                        // fname, lname, email
                        if (Helper.isNullOrWhitespace(inputs.FirstName)) {
                            firstname = items[0];
                        }
                        if (Helper.isNullOrWhitespace(inputs.LastName)) {
                            lastname = items[1];
                        }
                        if (Helper.isNullOrWhitespace(inputs.EmailAddress)) {
                            let temp = items[2];
                            email = temp.substring(1, temp.length - 1);
                        }
                    } else if (items.length == 2) {
                        // fname, email
                        if (Helper.isNullOrWhitespace(inputs.FirstName)) {
                            firstname = items[0];
                        }
                        if (Helper.isNullOrWhitespace(inputs.EmailAddress)) {
                            let temp = items[1];
                            email = temp.substring(1, temp.length - 1);
                        }
                    } else {
                        // email
                        if (Helper.isNullOrWhitespace(inputs.EmailAddress)) {
                            let temp = items[0];
                            email = temp.substring(1, temp.length - 1);
                        }
                    }
                }

                setInputs({...inputs, 
                    FirstName: firstname ? firstname : inputs.FirstName,
                    LastName: lastname ? lastname : inputs.LastName,
                    EmailAddress: email ? email : inputs.EmailAddress,
                });
            }
        }
    };

    // Designation

    const [designations, setDesignations] = useState<any[]>([]);
    const [selectedDesignation, setSelectedDesignation] = useState<any>();

    const getDesignations = async () => {
        let response = await CustomerService.getDesignations();
        let results = response.Results;
        setDesignations(results);

        if (!isNew) {
            if (contact.DesignationID) {
                setSelectedDesignation(results.find((x: any) => x.ID == contact.DesignationID));
            }
        }
    };

    const designationChange = async (value: any) => {
        setSelectedDesignation(value);
    };

    const [isPrimaryAlreadySet] = useState(isNew ? false : contact.IsPrimary);
    const [isPrimaryAccountAlreadySet] = useState(isNew ? false : module == Enums.Module.Customer ? contact.IsPrimaryAccount : false);

    const [inputErrors, setInputErrors] = useState<any>({});

    const validate = () => {
        let validationItems = [
            {key: 'FirstName', value: inputs.FirstName, required: true, type: Enums.ControlType.Text},
            {key: 'LastName', value: inputs.LastName, required: true, type: Enums.ControlType.Text},
            {key: 'MobileNumber', value: inputs.MobileNumber, type: Enums.ControlType.ContactNumber},
            {key: 'WorkNumber', value: inputs.WorkNumber, type: Enums.ControlType.ContactNumber},
            {key: 'HomeNumber', value: inputs.HomeNumber, type: Enums.ControlType.ContactNumber},
        ];
      
        if (module === Enums.Module.Customer) {
            validationItems = [...validationItems, 
                {key: 'EmailAddress', value: inputs.EmailAddress, type: Enums.ControlType.Email, multiEmail: true},
                {key: 'EmailAddress', value: inputs.EmailAddress, type: Enums.ControlType.Email, group: 'email_number', multiEmail: true},
                {key: 'MobileNumber', value: inputs.MobileNumber, type: Enums.ControlType.ContactNumber, group: 'email_number'}
            ];
        } else if (module === Enums.Module.Supplier) {
                if (inputs.canLogin === true && (isNew || !isNew && (inputs.password || inputs.confirmPassword || !inputs.UserID))) {
                    validationItems = [...validationItems,
                        {key: 'EmailAddress', value: inputs.EmailAddress, required: true, type: Enums.ControlType.Email, multiEmail: true},
                        {key: 'password', value: inputs.password, required: true, type: Enums.ControlType.Text, passwordLength: 8},
                        {key: 'confirmPassword', value: inputs.confirmPassword, required: true, type: Enums.ControlType.Text, equalsPassword: inputs.password}
                    ];
            } else {
                validationItems = [...validationItems, 
                    {key: 'EmailAddress', value: inputs.EmailAddress, type: Enums.ControlType.Email, multiEmail: true},
                    {key: 'EmailAddress', value: inputs.EmailAddress, type: Enums.ControlType.Email, group: 'email_number', multiEmail: true},
                    {key: 'MobileNumber', value: inputs.MobileNumber, type: Enums.ControlType.ContactNumber, group: 'email_number'}
                ];
            }
        }
      
        const {isValid, errors} = Helper.validateInputs(validationItems);
        setInputErrors(errors);

        return isValid;
    };

    const [saving, setSaving] = useState(false);

    // overrides: used by Activate to save the form as it stands with IsActive (and roles) set
    const saveContact = async (overrides: any = {}, successMessage = 'Contact saved successfully') => {

        setSaving(true);

        let isValid = validate();
        if (isValid) {
            let params = {...inputs, ...overrides, DesignationID: selectedDesignation ? selectedDesignation.ID : null};
           
            if (module == Enums.Module.Customer) {
                params = {...params,
                    CustomerID: moduleData.ID,
                };
            } else if (module == Enums.Module.Supplier) {
                params = {...params,
                    SupplierID: moduleData.ID,
                };
            }

            let response = {};
            if (isNew) {
                if (module == Enums.Module.Customer) {
                    response = await Fetch.post({
                        url: '/Contact',
                        params: params,
                        toastCtx: toast
                    });
                } else if (module == Enums.Module.Supplier) {
                    params = {
                        SupplierContact: params
                    };
                    if (inputs.canLogin && inputs.password == inputs.confirmPassword) {
                        params = {
                            ...params, User: {
                                UserName: inputs.EmailAddress,
                                IsActive: true,
                                Password: inputs.password,
                            }
                        };
                    }
                
                    response = await Fetch.post({
                        url: '/SupplierContact',
                        params: params,
                        toastCtx: toast
                    });
                }
            } else {
                if (module == Enums.Module.Customer) {
                    response = await Fetch.put({
                        url: '/Contact',
                        params: params,
                        toastCtx: toast
                    });
                } else if (module == Enums.Module.Supplier) { 
                    let userToSave = null;
                    if (inputs.canLogin || inputs.UserName) {
                        userToSave = {
                            UserName: inputs.UserName,
                            ID: inputs.UserID,
                            Password: inputs.password,
                            IsActive: params.IsActive && inputs.UserIsActive
                        };
                    }

                    response = await Fetch.put({
                        url: '/SupplierContact',
                            params: {
                            SupplierContact: params,
                            User: userToSave
                        },
                        toastCtx: toast
                    });
                }
            }

            if ((response as any).ID) {
                Helper.mixpanelTrack(isNew ? constants.mixPanelEvents.createContact  : constants.mixPanelEvents.editContact, {
                    "contactID": (response as any).ID
                });
                // Roles unticked on this contact go to the replacements picked for them
                const {promoted, allPromoted} = await promoteReplacements(replacements, 'Contact saved');
                if (allPromoted) {
                    toast.setToast!!!({
                        message: successMessage,
                        show: true,
                        type: 'success'
                    });
                }
                await finishSave(response, promoted);
            } else {
                toast.setToast!!!({
                    message: `Contact failed to save`,
                    show: true,
                    type: Enums.ToastType.error
                });
                setSaving(false);
            }
        } else {
            toast.setToast!!!({
                message: 'There are errors on the page',
                show: true,
                type: Enums.ToastType.error,
              });
            setSaving(false);
        }

        if (!isNew) {
            setSaving(false);
        }
    };

    // ===== Deactivate / activate =====
    // Deactivate saves the contact as it was loaded (unsaved edits are discarded, with a warning) and
    // hands its primary / accounting roles to another active contact. Activate saves the form as it stands.
    const isCustomer = module == Enums.Module.Customer;
    const ownerName = isCustomer ? 'customer' : 'supplier';
    const canChangeActiveStatus = !isNew && !!contact?.ID && editCustomerPermission;
    const isAccessLocked = accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess;
    const isInactive = !isNew && contact?.IsActive === false;
    const [changingActiveStatus, setChangingActiveStatus] = useState(false);
    const [deactivateCandidates, setDeactivateCandidates] = useState<any[] | null>(null);
    const deactivateRoles = {primary: !!contact?.IsPrimary, accounting: isCustomer && !!contact?.IsPrimaryAccount};

    const getActiveContacts = async (): Promise<any[]> => {
        const response = await Fetch.post({
            url: isCustomer ? '/Contact/GetContacts' : '/SupplierContact/GetContacts',
            params: {
                pageIndex: 0, pageSize: 1000, searchPhrase: '', IsActive: true,
                ...(isCustomer ? {customerID: moduleData?.ID} : {supplierID: moduleData?.ID}),
            },
        });
        if (!response?.Results) throw new Error('Could not load contacts');
        return response.Results.filter((x: any) => x.IsActive !== false);
    };

    const getOtherActiveContacts = async (): Promise<any[]> =>
        (await getActiveContacts()).filter((x: any) => x.ID !== contact?.ID);

    // Saving can change other contacts server side (a role moving demotes its previous holder), which gives
    // them a new RowVersion. Reload the active contacts so the caller can replace its copies: a stale
    // RowVersion fails the API's concurrency check the next time that contact is saved.
    // onSave receives (saved contact, the other active contacts as they are now).
    const finishSave = async (saved: any, fallbackRelated: any[]) => {
        if (!moduleData?.ID) {
            onSave(saved, fallbackRelated);
            return;
        }
        try {
            const latest = await getActiveContacts();
            onSave(latest.find((x: any) => x.ID === saved.ID) ?? saved, latest.filter((x: any) => x.ID !== saved.ID));
        } catch (e) {
            onSave(saved, fallbackRelated);
        }
    };

    // The other active contacts: candidates to take over a role this contact gives up, and to tell
    // whether this is the only active contact (null until loaded)
    const [otherContacts, setOtherContacts] = useState<any[] | null>(null);
    useEffect(() => {
        if (!moduleData?.ID) return;
        getOtherActiveContacts().then(setOtherContacts).catch(() => {});
    }, []);

    // A customer must keep at least one active contact; locations, by contrast, are optional
    const isOnlyActiveContact = isCustomer && !isInactive && otherContacts?.length === 0;
    const onlyContactReason = 'A customer needs at least one active contact. Please add another contact before deactivating this one.';

    // Saves a contact as loaded from the API (not the form), for deactivating and promoting
    const putContact = async (c: any) => {
        const response = isCustomer
            ? await Fetch.put({url: '/Contact', params: {...c, CustomerID: moduleData.ID}, toastCtx: toast})
            : await Fetch.put({
                url: '/SupplierContact',
                params: {
                    SupplierContact: {...c, SupplierID: moduleData.ID},
                    User: c.UserName ? {UserName: c.UserName, ID: c.UserID, Password: '', IsActive: c.IsActive && c.AuthUserIsActive} : null,
                },
                toastCtx: toast,
            });
        if (!response?.ID) throw new Error('Contact failed to save');
        return response;
    };

    const fail = (message: string) => toast.setToast!!!({message, show: true, type: Enums.ToastType.error});

    const startDeactivate = async () => {
        setChangingActiveStatus(true);
        try {
            const others = await getOtherActiveContacts();
            setOtherContacts(others);
            // Checked again here: the button state comes from the list loaded when the dialog opened
            if (isCustomer && others.length === 0) fail(onlyContactReason);
            else setDeactivateCandidates(deactivateRoles.primary || deactivateRoles.accounting ? others : []);
        } catch (e) {
            fail('Could not load contacts');
        }
        setChangingActiveStatus(false);
    };

    const confirmDeactivate = async ({primary, accounting}: any) => {
        setChangingActiveStatus(true);
        let response;
        try {
            // Deactivate first: promoting another contact demotes this one server side,
            // which would leave this contact's RowVersion stale for a second save.
            response = await putContact({...contact, IsActive: false, IsPrimary: false, ...(isCustomer && {IsPrimaryAccount: false})});
        } catch (e) {
            fail('Contact failed to deactivate');
            setChangingActiveStatus(false);
            return;
        }

        const {promoted, allPromoted} = await promoteReplacements({primary, accounting}, 'Contact deactivated');
        if (allPromoted) {
            toast.setToast!!!({message: 'Contact deactivated', show: true, type: 'success'});
        }
        setDeactivateCandidates(null);
        await finishSave(response, promoted);
    };

    // Gives this contact's roles to the chosen replacements, after this contact was saved.
    // The API keeps one primary and one accounting contact: promoting a contact demotes the previous
    // holder (it ignores unticking a role on an active contact, so promoting is the only way to move one).
    const promoteReplacements = async ({primary, accounting}: any, doneMessage: string) => {
        // One save per contact taking over a role (one save when one contact takes both)
        const takeovers: {contact: any, primary: boolean, accounting: boolean}[] = [];
        for (const [c, role] of [[primary, 'primary'], [accounting, 'accounting']] as const) {
            if (!c) continue;
            const existing = takeovers.find((t) => t.contact.ID === c.ID);
            if (existing) existing[role] = true;
            else takeovers.push({contact: c, primary: role === 'primary', accounting: role === 'accounting'});
        }

        const promoted: any[] = [];
        for (const t of takeovers) {
            try {
                // A save changes other contacts server side; reload so the RowVersion is current
                const latest = (await getOtherActiveContacts()).find((x: any) => x.ID === t.contact.ID) ?? t.contact;
                promoted.push(await putContact({
                    ...latest,
                    IsActive: true,
                    ...(t.primary && {IsPrimary: true}),
                    ...(t.accounting && {IsPrimaryAccount: true}),
                }));
            } catch (e) {
                const roleText = [t.primary && 'primary', t.accounting && 'accounting'].filter(Boolean).join(' and ');
                fail(`${doneMessage}, but ${fullName(t.contact)} could not be set as the ${roleText} contact`);
            }
        }
        return {promoted, allPromoted: promoted.length === takeovers.length};
    };

    const activate = async () => {
        if (!validate()) {
            fail('There are errors on the page');
            return;
        }
        setChangingActiveStatus(true);
        let others: any[];
        try {
            others = await getOtherActiveContacts();
        } catch (e) {
            fail('Contact failed to activate');
            setChangingActiveStatus(false);
            return;
        }
        setChangingActiveStatus(false);
        // Keep a primary (and accounting) contact: take the role when no active contact has it
        await saveContact({
            IsActive: true,
            IsPrimary: !!inputs.IsPrimary || !others.some((x) => x.IsPrimary),
            ...(isCustomer && {IsPrimaryAccount: !!inputs.IsPrimaryAccount || !others.some((x) => x.IsPrimaryAccount)}),
        }, 'Contact activated');
    };

    // Compared field by field so the deactivate prompt can warn about edits it discards
    const hasUnsavedChanges = (() => {
        if (!contact) return false;
        const same = (a: any, b: any) => (a ?? '') === (b ?? '');
        const fields = ['FirstName', 'LastName', 'EmailAddress', 'MobileNumber', 'WorkNumber', 'HomeNumber', 'FaxNumber', 'IDNumber'];
        return fields.some((f) => !same(inputs[f], contact[f]))
            || ['SendEmail', 'SendSMS', 'Unsubscribe', 'IsPrimary'].some((f) => !!inputs[f] !== !!contact[f])
            || (isCustomer && !!inputs.IsPrimaryAccount !== !!contact.IsPrimaryAccount)
            || !same(selectedDesignation?.ID, contact.DesignationID);
    })();

    // ===== Layout (per the "customer page update" design) =====
    const [showMoreNumbers, setShowMoreNumbers] = useState(
        !isNew && ['WorkNumber', 'HomeNumber', 'FaxNumber', 'IDNumber'].some((f) => !!contact?.[f])
    );

    const readOnly = !isNew && !editCustomerPermission;

    // ===== Roles =====
    // Ticking a role on another contact takes it from the current holder when saved (the API demotes them).
    // Unticking a role this contact holds asks which other active contact takes it over; cancelling keeps it.
    type Role = 'primary' | 'accounting';
    const roleField = {primary: 'IsPrimary', accounting: 'IsPrimaryAccount'} as const;
    const holdsRole = {primary: !!isPrimaryAlreadySet, accounting: !!isPrimaryAccountAlreadySet};
    const [replacements, setReplacements] = useState<{primary: any | null, accounting: any | null}>({primary: null, accounting: null});
    const [replacingRole, setReplacingRole] = useState<Role | null>(null);

    const toggleRole = (role: Role) => {
        const field = roleField[role];
        if (inputs[field] && holdsRole[role]) {
            setReplacingRole(role);
            return;
        }
        // Ticking it again keeps the role, so drop the replacement picked for it
        if (holdsRole[role]) setReplacements((r) => ({...r, [role]: null}));
        handleInputChange({name: field, value: !inputs[field]});
    };

    const confirmReplacement = (replacement: any) => {
        setReplacements((r) => ({...r, [replacingRole!]: replacement}));
        handleInputChange({name: roleField[replacingRole!], value: false});
        setReplacingRole(null);
    };

    const roleTargets = {primary: 'primary', accounting: 'primary accounting contact'};
    const roleState = (role: Role) => {
        const holds = holdsRole[role];
        // The current holder can only hand the role on to another active contact
        const noReplacement = holds && !otherContacts?.length;
        return {
            checked: inputs[roleField[role]],
            onChange: () => toggleRole(role),
            disabled: readOnly || noReplacement,
            lockedTooltip: noReplacement && otherContacts
                ? `This is the only active contact. To change it, set another contact as ${roleTargets[role]}.`
                : undefined,
        };
    };

    const badge = (label: string, color: string) => (
        <Badge key={label} variant={'light'} color={color} radius={'xl'} tt={'none'} fw={600}>{label}</Badge>
    );
    const statusBadges = isInactive
        ? [badge('Inactive', 'gray')]
        : [inputs.IsPrimary && badge('Primary', 'scBlue'), isCustomer && inputs.IsPrimaryAccount && badge('Accounting', 'scBlue')].filter(Boolean);

    const roleCheckbox = ({label, checked, onChange, disabled, lockedTooltip}: any) => (
        <Tooltip openDelay={300} label={lockedTooltip} color={'scBlue'} multiline w={280} disabled={!lockedTooltip} position={'top-start'}>
            <Box w={'fit-content'}>
                <Checkbox mt={'sm'} label={label} checked={!!checked} onChange={onChange} disabled={disabled}/>
            </Box>
        </Tooltip>
    );

    const deactivateDisabledReason = !canDeactivate ? 'This contact is in use here and can\'t be deactivated.'
        : isOnlyActiveContact ? onlyContactReason : undefined;

    return (
        <SCModal open={true} decor={'none'} onClose={() => {}} size={'lg'}>
            <div>
                {
                    backButtonText &&
                    <Group style={() => ({
                        borderBottom: `1px solid var(--mantine-color-gray-1)`,
                        paddingBottom: 'var(--mantine-spacing-md)'
                    })}>
                        <Button variant={'subtle'}
                                color={'gray.9'}
                                leftSection={<IconChevronLeft size={16}/>}
                                onClick={onCancel}
                        >
                            {backButtonText}
                        </Button>
                    </Group>
                }

                <Group my={'var(--mantine-spacing-lg)'} justify={'space-between'} align={'center'} wrap={'nowrap'} gap={'sm'}>
                    <Title size={'lg'} fw={600}>
                        {isNew ?
                            "Creating a contact" : `Editing contact ${inputs.FirstName ?? ''} ${inputs.LastName ?? ''}`
                        }
                    </Title>
                    {statusBadges.length > 0 && <Group gap={6} wrap={'nowrap'}>{statusBadges}</Group>}
                </Group>

                <SimpleGrid cols={{base: 1, sm: 2}} spacing={'sm'} verticalSpacing={0}>
                    <SCInput
                        onChange={handleInputChange}
                        error={inputErrors.FirstName}
                        label={"First name"}
                        name="FirstName"
                        required={true}
                        value={inputs.FirstName}
                        readOnly={readOnly}
                        cypress="data-cy-firstname"
                    />
                    <SCInput
                        onChange={handleInputChange}
                        error={inputErrors.LastName}
                        label={"Last name"}
                        name="LastName"
                        required={true}
                        value={inputs.LastName}
                        readOnly={readOnly}
                        cypress="data-cy-lastname"
                    />
                    <SCInput
                        onChange={handleInputChange}
                        onPaste={handleEmailOnPaste}
                        error={inputErrors.EmailAddress}
                        label={"Email"}
                        name="EmailAddress"
                        placeholder={"name@example.com"}
                        required={true}
                        value={inputs.EmailAddress}
                        readOnly={readOnly}
                        cypress="data-cy-email"
                    />
                    <div>
                        <SCInput
                            onChange={handleInputChange}
                            error={inputErrors.MobileNumber}
                            label={"Mobile number"}
                            name="MobileNumber"
                            required={true}
                            value={inputs.MobileNumber}
                            readOnly={readOnly}
                            type={'tel'}
                            cypress="data-cy-mobilenumber"
                        />
                        <Text mt={5} c={'gray.7'} size={'sm'}>Defaults to South Africa. For international numbers, include the country code.</Text>
                    </div>
                    <SCComboBox
                        label="Designation"
                        name="Designation"
                        textField="Description"
                        dataItemKey="ID"
                        options={designations}
                        placeholder=""
                        onChange={designationChange}
                        value={selectedDesignation}
                    />
                </SimpleGrid>

                {!showMoreNumbers ?
                    <Button variant={'subtle'} color={'scBlue'} size={'compact-sm'} mt={'sm'} px={0}
                            leftSection={<IconPlus size={14}/>}
                            onClick={() => setShowMoreNumbers(true)}
                    >
                        Add work, home or fax number, or ID number
                    </Button> :
                    <SimpleGrid cols={{base: 1, sm: 2}} spacing={'sm'} verticalSpacing={0}>
                        <SCInput
                            onChange={handleInputChange}
                            error={inputErrors.WorkNumber}
                            label={"Work number"}
                            name="WorkNumber"
                            value={inputs.WorkNumber}
                            readOnly={readOnly}
                            cypress="data-cy-worknumber"
                            type={'tel'}
                        />
                        <SCInput
                            onChange={handleInputChange}
                            error={inputErrors.HomeNumber}
                            label={"Home number"}
                            name="HomeNumber"
                            value={inputs.HomeNumber}
                            readOnly={readOnly}
                            cypress="data-cy-homenumber"
                            type={'tel'}
                        />
                        <SCInput
                            onChange={handleInputChange}
                            error={inputErrors.FaxNumber}
                            label={"Fax number"}
                            name="FaxNumber"
                            value={inputs.FaxNumber}
                            readOnly={readOnly}
                            cypress="data-cy-faxnumber"
                            type={'tel'}
                        />
                        <SCInput
                            onChange={handleInputChange}
                            error={inputErrors.IDNumber}
                            label={"ID number"}
                            name="IDNumber"
                            type={'tel'}
                            value={inputs.IDNumber}
                            readOnly={readOnly}
                            cypress="data-cy-idnumber"
                        />
                    </SimpleGrid>
                }

                <Box mt={'xl'}>
                    <Text fz={14} fw={600} c={'gray.9'}>Messages</Text>
                    <Text fz={13} c={'gray.6'}>When these are off, this contact can't be picked as a recipient.</Text>
                    <Checkbox
                        mt={'sm'}
                        label={'Send emails to this contact'}
                        checked={!!inputs.SendEmail}
                        onChange={() => handleInputChange({name: "SendEmail", value: !inputs.SendEmail})}
                        disabled={readOnly}
                    />
                    <Checkbox
                        mt={'sm'}
                        label={'Send SMS to this contact'}
                        checked={!!inputs.SendSMS}
                        onChange={() => handleInputChange({name: "SendSMS", value: !inputs.SendSMS})}
                        disabled={readOnly}
                    />
                    <Checkbox
                        mt={'sm'}
                        label={'Send SMS marketing'}
                        description={"Only if they've agreed to receive marketing."}
                        checked={!inputs.Unsubscribe}
                        onChange={() => handleInputChange({name: "Unsubscribe", value: !inputs.Unsubscribe})}
                        disabled={readOnly}
                    />
                </Box>

                <Box mt={'xl'}>
                    <Text fz={14} fw={600} c={'gray.9'}>Role for this {ownerName}</Text>
                    {roleCheckbox({label: 'Primary contact', ...roleState('primary')})}
                    {isCustomer && roleCheckbox({label: 'Primary accounting contact', ...roleState('accounting')})}
                </Box>

                <Group mt={'xl'} justify={'space-between'} gap={'xs'}>
                    <div>
                        {canChangeActiveStatus && (
                            <Tooltip color={'scBlue'} label={deactivateDisabledReason} disabled={!deactivateDisabledReason || isInactive} multiline w={260}>
                                <Box w={'fit-content'}>
                                    <Button
                                        type={'button'}
                                        variant={'outline'}
                                        color={isInactive ? 'scBlue' : 'red'}
                                        disabled={saving || changingActiveStatus || isAccessLocked || (!isInactive && !!deactivateDisabledReason)}
                                        rightSection={changingActiveStatus && !deactivateCandidates && <Loader variant={'oval'} size={18}/>}
                                        onClick={isInactive ? activate : startDeactivate}
                                    >
                                        {isInactive ? 'Activate' : 'Deactivate'}
                                    </Button>
                                </Box>
                            </Tooltip>
                        )}
                    </div>
                    <Group gap={'xs'}>
                        <Button type={'button'} variant={'subtle'} color={'gray.9'} onClick={onCancel}>
                            Cancel
                        </Button>
                        <Button color={'scBlue'}
                                disabled={saving || changingActiveStatus || isAccessLocked}
                                rightSection={saving && <Loader variant={'oval'} size={18} color={'white'}/>}
                                onClick={() => saveContact()}
                        >
                            {isNew ? 'Create' : 'Save'}
                        </Button>
                    </Group>
                </Group>
            </div>

            {replacingRole && (
                <ContactRoleReplacementModal
                    contact={contact}
                    roleName={replacingRole}
                    ownerName={ownerName}
                    candidates={otherContacts ?? []}
                    onConfirm={confirmReplacement}
                    onCancel={() => setReplacingRole(null)}
                />
            )}

            {deactivateCandidates && contact && (
                <ContactDeactivateModal
                    contact={contact}
                    roles={deactivateRoles}
                    candidates={deactivateCandidates}
                    ownerName={ownerName}
                    hasUnsavedChanges={hasUnsavedChanges}
                    saving={changingActiveStatus}
                    onConfirm={confirmDeactivate}
                    onCancel={() => setDeactivateCandidates(null)}
                />
            )}
        </SCModal>
    );
}

const fullName = (x: any) => x?.FullName || [x?.FirstName, x?.LastName].filter(Boolean).join(' ');

export default ManageContact;
